import LessonDetailsPage from './container'
export default LessonDetailsPage
